export default "__VITE_ASSET__BH3b06Uf__"